import { Routes, Route } from 'react-router-dom';

import { Navigate } from 'react-router-dom';
// layouts
import DashboardLayout from './layouts/dashboard';
import { useRecoilValue } from 'recoil';

import Login from './pages/Login';
import DashboardApp from './pages/DashboardApp';
import { userAtom } from './atoms/user';
import Requests from './pages/Requests';
import NotFound from './pages/Page404';
import NewRequest from './pages/NewRequest';
import Profile from './pages/Profile';
import Employees from './pages/Employees';
import NewEmployee from './pages/NewEmployee';
import EditEmployee from './pages/EditEmployee';
import FullScreenImage from './pages/FullScreenImage';
import ConfigPage from './pages/admin/ConfigPage';
import RoleBasedRoute from './layouts/RoleBasedRoute';
import AdminRequestPage from './pages/AdminRequestPage';
import EmployeeRequestPage from './pages/EmployeeRequestPage';
import DoctorRequestPage from './pages/DoctorRequestPage';
import FinanceRequestPage from './pages/FinanceRequestPage';
const rolesToRequestPageMap = {
  ADMIN: <AdminRequestPage />,
  EMPLOYEE: <EmployeeRequestPage />,
  DOCTOR: <DoctorRequestPage />,
  FINANCE: <FinanceRequestPage />
};
// ----------------------------------------------------------------------

export default function Router() {
  const user = useRecoilValue(userAtom);

  return (
    <Routes>
      <Route path="/dashboard" element={<DashboardLayout />}>
        <Route index element={<Navigate to="/dashboard/app" replace />} />
        <Route path="app" element={<DashboardApp />} />
        <Route path="profile" element={<Profile />} />
        <Route
          path="config"
          element={
            <RoleBasedRoute user={user} roles={['ADMIN', 'FINANCE']} external={user.external}>
              <ConfigPage />
            </RoleBasedRoute>
          }
        />
        <Route
          path="employees"
          element={
            <RoleBasedRoute user={user} roles={['ADMIN', 'FINANCE']}>
              <Employees />
            </RoleBasedRoute>
          }
        />
        <Route
          path="employees/new"
          element={
            <RoleBasedRoute user={user} roles={['ADMIN', 'FINANCE']}>
              <NewEmployee />
            </RoleBasedRoute>
          }
        />
        <Route
          path="employees/:id"
          element={
            <RoleBasedRoute user={user} roles={['ADMIN', 'FINANCE']}>
              <Profile employee={true} />
            </RoleBasedRoute>
          }
        />
        <Route
          path="employees/:id/update"
          element={
            <RoleBasedRoute user={user} roles={['ADMIN', 'FINANCE']}>
              <EditEmployee employee={true} />
            </RoleBasedRoute>
          }
        />

        <Route
          path="all-requests"
          element={
            <RoleBasedRoute user={user} roles={['EMPLOYEE']} exclude={true}>
              <Requests />
            </RoleBasedRoute>
          }
        />

        <Route
          path="all-requests/:id"
          element={
            <RoleBasedRoute user={user} roles={['EMPLOYEE']} exclude={true}>
              {rolesToRequestPageMap[user.role]}
            </RoleBasedRoute>
          }
        />
        <Route
          path="requests"
          element={
            <RoleBasedRoute user={user} roles={['DOCTOR']} exclude={true}>
              <Requests mine={true} />
            </RoleBasedRoute>
          }
        />
        <Route
          path="requests/new"
          element={
            <RoleBasedRoute user={user} roles={['DOCTOR']} exclude={true}>
              <NewRequest />
            </RoleBasedRoute>
          }
        />
        <Route
          path="requests/:id"
          element={
            <RoleBasedRoute user={user} roles={['DOCTOR']} exclude={true}>
              {rolesToRequestPageMap[user.role]}
            </RoleBasedRoute>
          }
        />
        <Route path="requests/images/:src" element={<FullScreenImage />} />
      </Route>

      <Route path="/">
        <Route path="login" element={<Login />} />
        <Route path="404" element={<NotFound />} />
        <Route index element={<Navigate to="/dashboard" />} />
        <Route path="*" element={<Navigate to="/404" />} />
      </Route>

      {/* Default route */}
      <Route path="*" element={<Navigate to="/404" replace />} />
    </Routes>
  );
}
